export default __webpack_public_path__ + "static/media/location_yellow.02f36d32.png";